import Cookies from 'js-cookie';
import jwt_decode from 'jwt-decode';

export const getJwtFromCookie = () => {
    const token = Cookies.get('Biodit');
    if (token) {
        return token;
    }

    const cookieRow = document.cookie
        .split('; ')
        .find(row => row.startsWith('Biodit='));

    if (!cookieRow) {
        return null;
    }

    return cookieRow.substring(cookieRow.indexOf('=') + 1);
};

export const decodeJwtPayload = token => {
    if (!token) {
        throw new Error('Missing token');
    }

    return jwt_decode(token);
};

export const getAdminIdFromCookie = () => {
    try {
        const token = getJwtFromCookie();
        if (!token) {
            return null;
        }

        const decoded = decodeJwtPayload(token);
        return decoded.id != null ? decoded.id : null;
    } catch (error) {
        console.error('Failed to read admin id from session cookie', error);
        return null;
    }
};
